import React from 'react';
import classnames from 'classnames';
import Text from 'src/components/Text';
import styles from './styles.module.scss';
import logo from './logo.svg';

type Props = {
  className?: string;
}

const SBPLogo: React.FC<Props> = ({ className}) => {
  const containerClassnames = classnames(styles['container'], className);
  
  return (
    <div className={containerClassnames}>
      <div className={styles['logo']}>
        <img src={logo} alt="" className={styles['img']} />
      </div>
      <Text type="logo">Агент 1С:СБП</Text>
    </div>
  );
};

export default SBPLogo;
